import React from "react";
import { createPortal } from "react-dom";

const BusyModeModal = ({ isOpen, onAcknowledge, onClose }) => {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-[9999] p-4">
      <div className="w-full max-w-[420px] bg-white rounded-2xl p-6 shadow-xl text-center">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-orange/10">
          <i className="fas fa-clock text-brand-orange text-2xl"></i>
        </div>

        <h3 className="text-lg font-bold text-black mb-2 font-['Prata',serif]">
          We're Really Busy Right Now
        </h3>

        <p className="text-sm text-black/70 leading-relaxed mb-6">
          We're currently experiencing a high volume of orders. Your order
          may take up to <strong>1 hour</strong> to prepare. Thank you for
          your patience!
        </p>

        <div className="flex gap-2.5">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 py-3 bg-[#f3f3f3] text-black rounded-full font-bold text-sm hover:opacity-80 transition-opacity"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onAcknowledge}
            className="flex-1 py-3 bg-brand-orange text-black rounded-full font-bold text-sm hover:opacity-90 transition-opacity"
          >
            Continue
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default BusyModeModal;
